import { IconAttention, IconChevronRight } from '@divlab/divanui/icons';
import { cn } from '@divlab/divanui';

import styles from './AdditionalPeriodBlock.module.css';

import type { FC, HTMLAttributes } from 'react';

interface AdditionalPeriodBlockProps extends HTMLAttributes<HTMLDivElement> {
  text: string;
  period: string;
  tooltip: string;
  icon: 'attention' | 'chevron';
  showedTooltip: boolean;
  onChevronClick?: () => void;
  onToggleTooltip?: () => void;
  blockRef?: React.RefObject<HTMLDivElement>;
}

const AdditionalPeriodBlock: FC<AdditionalPeriodBlockProps> = ({
  className,
  text,
  period,
  tooltip,
  icon,
  showedTooltip,
  onChevronClick,
  onToggleTooltip,
  blockRef,
  ...restProps
}) => (
  <div {...restProps} className={cn(styles.block, className)}>
    <div>
      <span className={styles.bold}>{text}</span> {period}
    </div>

    {icon === 'attention' && (
      <div className={styles.icon} ref={blockRef} onClick={onToggleTooltip}>
        <IconAttention />
      </div>
    )}

    {icon === 'chevron' && onChevronClick && (
      <IconChevronRight className={styles.icon} onClick={onChevronClick} />
    )}

    {showedTooltip && <div className={styles.tooltip}>{tooltip}</div>}
  </div>
);

export default AdditionalPeriodBlock;
